import { styled } from '@glitz/react';
import * as style from '../Style';

export default styled.h3({
  fontSize: style.gamma,
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: '2px',
});
